import { Debt } from '../../interfaces';
import { getAllOpenHouseholdDebtsByAccountTypes } from './getAllOpenHouseholdDebtsByAccountTypes';

export const STUDENT_LOAN_ACCOUNT_TYPES = ['ST'];

export const getAllHouseholdStudentLoans = (borrowerDebts: Debt[] = [], spouseDebts: Debt[] = []): Debt[] =>
  getAllOpenHouseholdDebtsByAccountTypes(borrowerDebts, spouseDebts, STUDENT_LOAN_ACCOUNT_TYPES);
